document.addEventListener("DOMContentLoaded", function () {

    const dateInput = document.getElementById("order-date");
    const timeInput = document.getElementById("order-time");

    // Tomorrow onwards
    if (dateInput) {
        const today = new Date();
        today.setDate(today.getDate() + 1);

        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");

        dateInput.min = `${yyyy}-${mm}-${dd}`;
    }

    // Pickup / Delivery buttons
    const pickup = document.getElementById("pickup");
    const delivery = document.getElementById("delivery");

    function updateButtons() {
        document.querySelector("label[for='pickup']").classList.toggle("active", pickup.checked);
        document.querySelector("label[for='delivery']").classList.toggle("active", delivery.checked);
    }

    if (pickup && delivery) {
        pickup.addEventListener("change", updateButtons);
        delivery.addEventListener("change", updateButtons);
        updateButtons();
    }

    // Add to cart validation
    const addToCart =
        document.querySelector('button[name="add"]') ||
        document.querySelector('.product-form__submit');

    function validateForm() {
        if (!addToCart) return;

        if (dateInput.value !== "" && timeInput.value !== "") {
            addToCart.disabled = false;
        } else {
            addToCart.disabled = true;
        }
    }

    if (dateInput && timeInput) {
        dateInput.addEventListener("change", validateForm);
        timeInput.addEventListener("change", validateForm);
        validateForm();
    }

});